import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchCompanyMerge } from '@/api/(admin)/companies';
import { isMergeActive } from '@/lib/constants/companyMerge';
import { companyMergesQueryKey } from './useCompanyMergesList';

/** How often a running merge's progress is refreshed. */
const POLL_MS = 2000;

export function companyMergeDetailQueryOptions(mergeId: string) {
  return queryOptions({
    queryKey: [...companyMergesQueryKey, 'detail', mergeId] as const,
    queryFn: () => fetchCompanyMerge(mergeId),
    refetchInterval: q => (isMergeActive(q.state.data?.data) ? POLL_MS : false),
  });
}

/** One merge with every group's progress. Polls while it is moving data,
 *  then stops on its own. */
export function useCompanyMergeDetail(mergeId: string) {
  const query = useQuery(companyMergeDetailQueryOptions(mergeId));
  return { ...query, merge: query.data?.data };
}
